import React from 'react';
import ListItem from 'components/ListItem';
import { SprayEventIsFinalSpray } from 'services/sprayEvents/types';

export interface OwnProps {
    isFinalSpray?: SprayEventIsFinalSpray;
}

type Props = OwnProps;

export default class SummaryApplicationIsFinalSpray extends React.PureComponent<
    Props
> {
    render(): React.ReactElement | null {
        const { isFinalSpray } = this.props;

        return (
            <ListItem
                description="Spray is final"
                value={isFinalSpray ? 'Yes' : 'No'}
            />
        );
    }
}
